import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/home/src/features/home/ui/HomePage/index.tsx");
